import { render, staticRenderFns } from "./InterpretationHistoryTable.vue?vue&type=template&id=275acbc4&"
import script from "./InterpretationHistoryTable.vue?vue&type=script&lang=js&"
export * from "./InterpretationHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports